import { render, staticRenderFns } from "./distributionTask.vue?vue&type=template&id=1cd6c1d0&scoped=true"
import script from "./distributionTask.vue?vue&type=script&lang=js"
export * from "./distributionTask.vue?vue&type=script&lang=js"
import style1 from "./distributionTask.vue?vue&type=style&index=1&id=1cd6c1d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd6c1d0",
  null
  
)

export default component.exports